/* Studio's: live openingsstatus, afstand-sortering en mobiele sticky. */
(function () {
  var DAYS = { zo: 0, ma: 1, di: 2, wo: 3, do: 4, vr: 5, za: 6 };

  /* Alle zichtbare tekst komt uit de sectie-instellingen, zodat hij per taal
     vertaald kan worden. De waarden hieronder zijn alleen de terugval. */
  var T = {
    days: 'zondag, maandag, dinsdag, woensdag, donderdag, vrijdag, zaterdag',
    openUntil: 'Nu geopend tot {time}',
    closedToday: 'Nu gesloten, opent vandaag om {time}',
    closedTomorrow: 'Nu gesloten, opent morgen om {time}',
    closedDay: 'Nu gesloten, opent {day} om {time}',
    byAppointment: 'Op afspraak',
    distance: '{km} km van jou',
    locating: 'Zoeken…',
    noLocation: 'Locatie niet beschikbaar. Geef toestemming in je browser of vul een postcode in.'
  };
  var i18nEl = document.querySelector('[data-sf-i18n]');
  if (i18nEl) {
    try {
      var given = JSON.parse(i18nEl.textContent);
      for (var key in given) { if (given[key]) T[key] = given[key]; }
    } catch (e) {}
  }
  var DAY_NAMES = T.days.split(',').map(function (d) { return d.trim(); });

  function say(template, values) {
    return String(template).replace(/\{(\w+)\}/g, function (match, name) {
      return values[name] === undefined ? match : values[name];
    });
  }

  /* "ma-vr=10:00-17:00" per regel; "za=10:00-16:00"; "zo=dicht" */
  function parseHours(raw) {
    var table = {};
    if (!raw) return table;
    raw.split('\n').forEach(function (line) {
      line = line.trim().toLowerCase();
      if (!line || line.indexOf('=') === -1) return;
      var parts = line.split('=');
      var days = parts[0].trim();
      var times = parts[1].trim();
      var from = null, to = null;
      var m = times.match(/(\d{1,2})[:.](\d{2})\s*-\s*(\d{1,2})[:.](\d{2})/);
      if (m) { from = parseInt(m[1], 10) * 60 + parseInt(m[2], 10); to = parseInt(m[3], 10) * 60 + parseInt(m[4], 10); }
      var list = [];
      if (days.indexOf('-') > -1) {
        var d = days.split('-');
        var a = DAYS[d[0].trim()], b = DAYS[d[1].trim()];
        if (a === undefined || b === undefined) return;
        var i = a;
        while (true) { list.push(i); if (i === b) break; i = (i + 1) % 7; }
      } else if (DAYS[days] !== undefined) {
        list = [DAYS[days]];
      }
      list.forEach(function (day) { table[day] = m ? { from: from, to: to } : null; });
    });
    return table;
  }

  function fmt(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    return h + ':' + (m < 10 ? '0' + m : m);
  }

  function nowInNL() {
    var p = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Amsterdam', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
    var out = {};
    p.forEach(function (x) { out[x.type] = x.value; });
    var wd = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[out.weekday.slice(0, 3)];
    return { day: wd, mins: parseInt(out.hour, 10) * 60 + parseInt(out.minute, 10) };
  }

  function status(table) {
    var now = nowInNL();
    var today = table[now.day];
    if (today && now.mins >= today.from && now.mins < today.to) {
      return { open: true, text: say(T.openUntil, { time: fmt(today.to) }) };
    }
    if (today && now.mins < today.from) {
      return { open: false, text: say(T.closedToday, { time: fmt(today.from) }) };
    }
    var todayDefined = !!today;
    for (var i = 1; i <= 7; i++) {
      var d = (now.day + i) % 7;
      if (table[d]) {
        var text = (i === 1 && todayDefined)
          ? say(T.closedTomorrow, { time: fmt(table[d].from) })
          : say(T.closedDay, { day: DAY_NAMES[d], time: fmt(table[d].from) });
        return { open: false, text: text };
      }
    }
    return { open: false, text: T.byAppointment };
  }

  function applyStatus(scope) {
    (scope || document).querySelectorAll('[data-sf-hours]').forEach(function (el) {
      var table = parseHours(el.getAttribute('data-sf-hours'));
      if (!Object.keys(table).length) return;
      var s = status(table);
      if (!s.open && el.hasAttribute('data-sf-hide-closed')) {
        el.style.display = 'none';
        return;
      }
      el.style.display = '';
      el.textContent = s.text;
      el.classList.toggle('open', s.open);
    });
  }

  function haversine(a, b) {
    var R = 6371, rad = Math.PI / 180;
    var dLat = (b.lat - a.lat) * rad, dLng = (b.lng - a.lng) * rad;
    var q = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * rad) * Math.cos(b.lat * rad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(q), Math.sqrt(1 - q));
  }

  function initOverview() {
    var root = document.querySelector('[data-sf-studios]');
    if (!root) return;
    var grid = root.querySelector('.sf-sto-grid');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.sf-sto-card'));
    var sticky = root.querySelector('.sf-st-sticky');
    var restHint = root.querySelector('[data-sf-rest-hint]');
    var sorted = false;

    /* Na het sorteren blijft de dichtstbijzijnde studio staan en schuiven de overige
       in een eigen scrollvlak, zodat de lijst niet de hele pagina vult. */
    var restTimer = null;

    function stopRestCarousel() {
      if (restTimer) { clearInterval(restTimer); restTimer = null; }
    }

    /* Exact hetzelfde ritme en gedrag als de ruimte-keuze op de homepage,
       zie sf-room-choice.js: elke vijf seconden een kaart verder, heen en
       weer, en stil zodra de bezoeker zelf schuift. */
    function startRestCarousel(rooms) {
      stopRestCarousel();
      var cards = rooms.querySelectorAll('.sf-sto-card');
      if (!cards.length) return;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) return;
      var isMobile = function () { return window.matchMedia('(max-width:749px)').matches; };
      var idx = 0, dir = 1, playing = true;
      var DWELL_MS = 5000;
      function goTo(i) {
        idx = i;
        var roomsRect = rooms.getBoundingClientRect();
        var cardRect = cards[idx].getBoundingClientRect();
        var target = rooms.scrollLeft + (cardRect.left - roomsRect.left);
        rooms.scrollTo({ left: target, behavior: 'smooth' });
      }
      function stop() { playing = false; }
      ['pointerdown', 'wheel'].forEach(function (evt) { rooms.addEventListener(evt, stop, { passive: true }); });
      restTimer = setInterval(function () {
        if (!playing || !isMobile() || !document.body.contains(rooms)) return;
        var next = idx + dir;
        if (next >= cards.length || next < 0) { dir = -dir; next = idx + dir; }
        goTo(next);
      }, DWELL_MS);
    }

    function applyRest() {
      stopRestCarousel();
      var rest = grid.querySelector('.sf-sto-rest');
      if (rest) {
        while (rest.firstChild) grid.insertBefore(rest.firstChild, rest);
        grid.removeChild(rest);
      }
      root.classList.remove('has-rest');
      if (!sorted || cards.length < 3) return;
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      rest = document.createElement('div');
      rest.className = 'sf-sto-rest';
      grid.appendChild(rest);
      for (var i = 1; i < cards.length; i++) rest.appendChild(cards[i]);
      if (restHint) grid.insertBefore(restHint, rest);
      root.classList.add('has-rest');
      startRestCarousel(rest);
    }

    /* De kaart (Google My Maps) springt naar de gezochte plek en de dichtstbijzijnde
       studio. Het zoomniveau volgt de afstand, zodat beide in beeld blijven. */
    var mapFrame = root.querySelector('.sf-sto-map iframe');
    var mapBase = mapFrame ? (mapFrame.getAttribute('src') || '') : '';
    function moveMap(origin, nearest) {
      if (!mapFrame || mapBase.indexOf('/maps/d/embed') === -1 || !nearest) return;
      var nLat = parseFloat(nearest.getAttribute('data-lat'));
      var nLng = parseFloat(nearest.getAttribute('data-lng'));
      if (isNaN(nLat) || isNaN(nLng)) return;
      var distM = haversine(origin, { lat: nLat, lng: nLng }) * 1000;
      var lat = (origin.lat + nLat) / 2, lng = (origin.lng + nLng) / 2;
      var room = Math.max(120, Math.min(mapFrame.clientWidth || 340, (mapFrame.clientHeight || 360) - 96));
      var z = distM < 50 ? 13 : Math.floor(Math.log(156543.03 * Math.cos(lat * Math.PI / 180) * room / (distM * 1.8)) / Math.LN2);
      z = Math.max(7, Math.min(13, z));
      var base = mapBase.replace(/[&?](ll|z)=[^&]*/g, '');
      mapFrame.src = base + '&ll=' + lat.toFixed(4) + ',' + lng.toFixed(4) + '&z=' + z;
    }

    function sortByOrigin(origin, opts) {
      cards.forEach(function (card) {
        var lat = parseFloat(card.getAttribute('data-lat'));
        var lng = parseFloat(card.getAttribute('data-lng'));
        if (isNaN(lat) || isNaN(lng)) return;
        var km = Math.round(haversine(origin, { lat: lat, lng: lng }));
        card.setAttribute('data-km', km);
        var d = card.querySelector('.sf-sto-card__distance');
        if (d) d.textContent = say(T.distance, { km: km });
      });
      function sortKey(card) {
        var km = parseFloat(card.getAttribute('data-km'));
        return isNaN(km) ? 1e9 : km;
      }
      cards.sort(function (a, b) { return sortKey(a) - sortKey(b); });
      cards.forEach(function (card) { grid.appendChild(card); });
      moveMap(origin, cards[0]);
      (function announce() {
        var first = cards[0];
        if (!first) return;
        var nLat = parseFloat(first.getAttribute('data-lat'));
        var nLng = parseFloat(first.getAttribute('data-lng'));
        if (isNaN(nLat) || isNaN(nLng)) return;
        document.dispatchEvent(new CustomEvent('sf-studios:sorted', {
          detail: { origin: origin, source: opts && opts.source, nearest: { lat: nLat, lng: nLng, km: parseFloat(first.getAttribute('data-km')) || 0 } }
        }));
      })();
      sorted = true;
      applyRest();
      fillSticky();
    }

    function fillSticky() {
      if (!sticky) return;
      var nameEl = sticky.querySelector('.sf-st-sticky-name');
      var subEl = sticky.querySelector('.sf-st-sticky-sub');
      var generic = sticky.querySelectorAll('[data-sticky-online], [data-sticky-samplebox]');
      var perStudio = sticky.querySelectorAll('[data-sticky-view], [data-sticky-route], [data-sticky-appoint]');
      function show(el, on) { el.style.display = on ? '' : 'none'; }

      /* Zonder gekozen locatie (geen postcode, geen locatie-toestemming) zetten we
         niet zomaar de eerste studio in de balk, maar de algemene knoppen:
         online afspraak en samplebox. */
      if (!sorted) {
        nameEl.textContent = sticky.getAttribute('data-default-name') || '';
        subEl.textContent = sticky.getAttribute('data-default-sub') || '';
        perStudio.forEach(function (el) { show(el, false); });
        generic.forEach(function (el) {
          var href = el.getAttribute('href');
          show(el, !!href && href !== '#');
        });
        return;
      }
      generic.forEach(function (el) { show(el, false); });

      var first = null;
      for (var i = 0; i < cards.length; i++) {
        if (!cards[i].hasAttribute('data-soon') && !cards[i].hasAttribute('data-no-actions')) { first = cards[i]; break; }
      }
      if (!first) first = cards[0];
      if (!first) return;
      var name = first.getAttribute('data-name') || '';
      var km = first.getAttribute('data-km');
      var st = first.querySelector('[data-sf-hours]');
      nameEl.textContent = name + (km ? ' · ' + km + ' km' : '');
      subEl.textContent = st ? st.textContent : '';
      var noActions = first.hasAttribute('data-no-actions');
      function fill(el, value) {
        if (!el) return;
        el.setAttribute('href', value || '#');
        el.style.display = (noActions || !value) ? 'none' : '';
      }
      fill(sticky.querySelector('[data-sticky-view]'), first.getAttribute('data-url'));
      fill(sticky.querySelector('[data-sticky-route]'), first.getAttribute('data-route'));
      fill(sticky.querySelector('[data-sticky-appoint]'), first.getAttribute('data-appoint'));
    }

    /* Zoeken op plaats of postcode.
       PDOK is het nauwkeurigst voor Nederland maar kent alleen Nederland.
       Nominatim dekt de rest van Europa, zodat Belgen en Duitsers hun
       dichtstbijzijnde studio ook vinden. */
    var NL_FULL = /^\d{4}\s*[a-z]{2}$/i;
    var COUNTRIES = 'nl,be,de,lu,fr,at,ch,dk,gb,es,it';

    function preferredCountry() {
      var lang = (navigator.languages && navigator.languages[0]) || navigator.language || '';
      var m = lang.match(/[-_]([A-Za-z]{2})$/);
      return m ? m[1].toLowerCase() : '';
    }

    function pdok(q, fq) {
      var url = 'https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?rows=1&q=' + encodeURIComponent(q)
        + (fq ? '&fq=' + encodeURIComponent(fq) : '');
      return fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var doc = data && data.response && data.response.docs && data.response.docs[0];
          if (!doc || !doc.centroide_ll) return null;
          var m = doc.centroide_ll.match(/POINT\(([\d.]+) ([\d.]+)\)/);
          return m ? { lng: parseFloat(m[1]), lat: parseFloat(m[2]), doc: doc } : null;
        })
        .catch(function () { return null; });
    }

    /* Postcodes zoeken we als postcode. Een vrije zoekopdracht liet 'Aa' in een
       niet-bestaande postcode (bijv. 4811 AA) gelden als de gemeente Aa en Hunze.
       Bestaat de volledige postcode niet, dan valt het terug op het gebied van de
       vier cijfers. Alleen een plaatsnaam of adres gaat als vrije tekst. */
    function lookupNl(q) {
      var compact = q.replace(/\s/g, '').toUpperCase();
      var area = compact.slice(0, 4);
      function sameArea(hit) {
        if (!hit) return null;
        var name = String(hit.doc.postcode || hit.doc.weergavenaam || '').replace(/\s/g, '').toUpperCase();
        return name.indexOf(area) === 0 ? { lat: hit.lat, lng: hit.lng } : null;
      }
      if (/^\d{4}[A-Z]{2}$/.test(compact)) {
        return pdok(compact, 'type:postcode').then(function (hit) {
          return sameArea(hit) || pdok(area, 'type:postcode').then(sameArea);
        });
      }
      if (/^\d{4}$/.test(compact)) {
        return pdok(compact, 'type:postcode').then(sameArea);
      }
      return pdok(q).then(function (hit) { return hit ? { lat: hit.lat, lng: hit.lng } : null; });
    }

    function lookupEurope(q, countries) {
      var url = 'https://nominatim.openstreetmap.org/search?format=jsonv2&limit=5&addressdetails=1'
        + '&countrycodes=' + (countries || COUNTRIES)
        + '&accept-language=' + encodeURIComponent(document.documentElement.lang || 'nl')
        + '&q=' + encodeURIComponent(q);
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (list) {
          if (!list || !list.length) return null;
          var want = preferredCountry();
          var hit = null;
          if (want) {
            for (var i = 0; i < list.length; i++) {
              var address = list[i].address || {};
              if (address.country_code === want) { hit = list[i]; break; }
            }
          }
          if (!hit) hit = list[0];
          var lat = parseFloat(hit.lat), lng = parseFloat(hit.lon);
          return (isNaN(lat) || isNaN(lng)) ? null : { lat: lat, lng: lng };
        })
        .catch(function () { return null; });
    }

    /* Vier losse cijfers zijn zowel een Nederlandse als een Belgische postcode.
       De taalinstelling van de browser geeft de doorslag; ontbreekt die, dan
       kijken we eerst in Nederland omdat daar de studio's staan. */
    function geocode(q) {
      var bare = /^\d{4}$/.test(q.replace(/\s/g, ''));
      var want = preferredCountry();
      var dutchFirst = NL_FULL.test(q) || (bare && (!want || want === 'nl'));
      if (bare) {
        /* Vier cijfers bestaan in meerdere landen. Nederland en België komen eerst,
           want daar wonen onze klanten; pas daarna de rest van Europa. */
        var order = dutchFirst ? [lookupNl, function (t) { return lookupEurope(t, 'be'); }]
                               : [function (t) { return lookupEurope(t, 'be'); }, lookupNl];
        return order[0](q).then(function (hit) { return hit || order[1](q); })
          .then(function (hit) { return hit || lookupEurope(q); });
      }
      if (dutchFirst) {
        return lookupNl(q).then(function (hit) { return hit || lookupEurope(q); });
      }
      return lookupEurope(q).then(function (hit) { return hit || lookupNl(q); });
    }

    var form = root.querySelector('[data-sf-postcode]');
    var searchError = document.querySelector('[data-sf-search-error]');

    var notFoundText = searchError ? searchError.textContent : '';

    /* Zonder tekst toont de melding de standaard 'niets gevonden'-tekst uit de
       sectie; met tekst (bijv. locatie geweigerd) tijdelijk die tekst. */
    function showError(on, text) {
      if (!searchError) return;
      searchError.textContent = (on && text) ? text : notFoundText;
      searchError.classList.toggle('is-on', !!on);
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = form.querySelector('input').value.trim();
        if (!q) return;
        showError(false);
        form.classList.add('is-busy');
        geocode(q).then(function (hit) {
          form.classList.remove('is-busy');
          if (hit) sortByOrigin(hit);
          else showError(true);
        });
      });
    }

    /* Lokaliseren. Alleen op verzoek (klik op 'Mijn locatie') of als de bezoeker
       deze site al eerder toestemming gaf. Een ongevraagde locatievraag bij het
       laden negeren of blokkeren browsers steeds vaker, en dan leek de knop
       daarna niets te doen. De knop laat zien dat hij bezig is en meldt het als
       de locatie niet beschikbaar is. */
    var locateBtn = root.querySelector('[data-sf-locate]');
    var locateLabel = locateBtn ? locateBtn.textContent : '';

    function setLocating(on) {
      if (!locateBtn) return;
      locateBtn.disabled = on;
      locateBtn.classList.toggle('is-busy', on);
      locateBtn.textContent = on ? T.locating : locateLabel;
    }

    function locate(fromClick) {
      if (!navigator.geolocation) {
        if (fromClick) showError(true, T.noLocation);
        return;
      }
      showError(false);
      if (fromClick) setLocating(true);
      navigator.geolocation.getCurrentPosition(function (pos) {
        setLocating(false);
        sortByOrigin({ lat: pos.coords.latitude, lng: pos.coords.longitude }, { source: fromClick ? 'locate' : 'auto' });
        /* Met de eigen kaart houden we de kaart in beeld: die navigeert naar de
           dichtstbijzijnde studio. Zonder eigen kaart schuiven we naar de lijst. */
        var mapBox = root.querySelector('[data-sf-map]');
        if (fromClick && mapBox && mapBox.scrollIntoView) {
          var r = mapBox.getBoundingClientRect();
          if (r.top < 0 || r.bottom > (window.innerHeight || 800)) mapBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (fromClick && grid && grid.scrollIntoView) {
          grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, function () {
        setLocating(false);
        if (fromClick) showError(true, T.noLocation);
      }, { maximumAge: 600000, timeout: 8000 });
    }

    if (locateBtn) locateBtn.addEventListener('click', function () { locate(true); });
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'geolocation' }).then(function (status) {
        if (status.state === 'granted') locate(false);
      }).catch(function () {});
    }
    if (window.matchMedia) {
      var mq = window.matchMedia('(max-width: 749px)');
      if (mq.addEventListener) mq.addEventListener('change', applyRest);
      else if (mq.addListener) mq.addListener(applyRest);
    }
    fillSticky();
    initSticky(root, sticky);
  }

  function initDetail() {
    var root = document.querySelector('[data-sf-studio]');
    if (!root) return;
    initSticky(root, root.querySelector('.sf-st-sticky'));
  }

  /* Markeer de pagina zolang de balk in beeld staat, zodat een chatbubbel
     erboven kan schuiven in plaats van eroverheen. */
  function setSticky(sticky, on) {
    sticky.classList.toggle('visible', on);
    document.body.classList.toggle('sf-sticky-on', on);
  }

  function initSticky(root, sticky) {
    if (!sticky) return;
    var marker = root.querySelector('[data-sticky-after]') || root;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        setSticky(sticky, !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(marker);
    } else {
      setSticky(sticky, true);
    }
  }

  function init() {
    applyStatus(document);
    initOverview();
    initDetail();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
